<template>
    <div v-if="visible" class="mb-4">
        <label class="form-label" :for="name">{{ label }}</label>
        <select :id="name" :name="name" ref="customerPicker" style="width:100%"></select>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        defaultValue: {
            type: String,
            required: false,
        },
        routes: Object,
        showIf: {
            type: String,
            required: false,
        },
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        }
    },
    data () {
        return {
            hasChanged: false,
            picker: null,
            visible: false,
        };
    },
    mounted () {
        if (this.showIf) {
            this.shouldShow();
            window.jQuery(this.showIf).on('change', () => {
                this.hasChanged = true;
                this.shouldShow();
            });
        } else {
            this.visible = true;
        }
    },
    watch: {
        visible () {
            setTimeout(this.createOrDestroy, 100);
        }
    },
    methods: {
        async createOrDestroy() {
            if (this.visible) {
                this.picker = window.jQuery(this.$refs.customerPicker).select2({
                    dropdownParent: this.$el,
                    placeholder: 'Select Customer',
                    ajax: {
                        cache: true,
                        data: function(params) {
                            return {
                                search: params.term,
                                page: params.page
                            };
                        },
                        dataType: 'json',
                        delay: 250,
                        processResults: function(data) {
                            // why do we need to do this?
                            return {
                                results: data.data
                            };
                        },
                        url: this.routes.customerFilter,
                    }
                });

                if (this.hasChanged === false && this.defaultValue.length > 0) {
                    let chosenOne = await axios.get(this.routes.getDefaultValue.replace('replace-me', this.defaultValue))
                        .then((response) => {
                            if (response.data.data.length != 1) {
                                throw new Error('invalid data received');
                            }
                            return response.data.data[0];
                        });

                    this.picker.append(window.jQuery('<option selected>' + (chosenOne.text || chosenOne.title) + '</option>').val(chosenOne.id));
                    this.picker.trigger('change');
                }
            } else {
                this.picker.select2('destroy');
            }
        },
        shouldShow () {
            this.visible = (window.jQuery(this.showIf).val() == 'Customer');
        }
    }
}
</script>
